module.exports = __webpack_public_path__ + "static/media/take_me.2f902c77.png";